import { httpMobile } from "@/utils/httpMobile"

// "client_id":"9932764"  待确认  是否需要
//商品标签  http://api.newdhb.com/api.php?c=OrderManager&a=getDistributionModeList
export interface ServiceFilterDeliverType {
  "code": number // 100,
  "message": string // "",
  "action_time": number // 1722241271,
  "data": {
    "count": number // 2,
    "list": [
      {
        "id": string // "59",
        "company_id": string // "311",
        "name": string // "快递",
        "type": string // "1",
        "status": string // "1",
        "is_default": string // "0",
        "is_sys": string // "1",
        "customer_type": string // "0",
        "customer_region": string // "0",
        "create_time": string // "2022-01-25 22:43:32",
        "update_time": string // "2022-01-25 22:43:32",
        "is_delete": string // "0"
      }
    ]
  }
}


export const serviceFilterDeliverType = async  () => {
  return  httpMobile.post<ServiceFilterDeliverType>(`/api.php`,{
    a:'getDistributionModeList',
    c:"OrderManager"
  })
}